import React, {Component} from "react";
import logoSlider from "../upgrade_components/upgrade/logoSlider"

export default logoSlider;

